// Lista centralizada de métodos de pago y helper para filtrar por configuración
// Puedes controlar qué métodos mostrar con la variable de entorno
// REACT_APP_ENABLED_PAYMENT_METHODS (ej: "culqi,cod,stripe"). Si no se define,
// se muestran todos los métodos por defecto.

export const PAYMENT_METHODS = [
  {
    id: "cod",
    name: "CONTRA ENTREGA",
    image: "/images/payment/cod.jpg",
    description: "Paga en efectivo al recibir tu pedido",
  },
  {
    id: "culqi",
    name: "CULQI",
    image: "/images/payment/culqi-logo.png",
    description: "Pago con tarjeta de crédito/débito, Yape y más",
  },
  {
    id: "stripe",
    name: "STRIPE",
    image: "/images/payment/stripe.png",
    description: "Pago con Stripe (tarjeta de crédito/débito)",
  },
];

export function getEnabledPaymentMethods(envVar = process.env.REACT_APP_ENABLED_PAYMENT_METHODS) {
  if (!envVar) return PAYMENT_METHODS;
  const enabled = String(envVar)
    .split(",")
    .map(s => s.trim())
    .filter(Boolean);
  // Preserve order from PAYMENT_METHODS
  return PAYMENT_METHODS.filter(m => enabled.includes(m.id));
}

export default PAYMENT_METHODS;
